var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.029 59.2544C149.203 54.3562 140.289 54.9397 135.231 60.9709L132.191 64.5672L153.737 82.645L156.639 79.0618C161.631 73.1243 161 64.2569 155.029 59.2544Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1781 109.543L92.5747 111.44C91.1831 113.107 90.1806 115.098 89.6772 117.208L85.3194 135.445C84.9075 137.171 85.5072 138.984 86.8666 140.124C88.1897 141.236 90.056 141.559 91.7419 140.838L108.949 133.376C110.94 132.511 112.726 131.179 114.117 129.527L115.726 127.623L94.1781 109.543Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.144 71.7227L100.23 102.383L121.777 120.463L147.689 89.8005L126.144 71.7227Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.506 20.7844L99.6989 3.86531C98.0155 2.26937 95.9445 1.32937 93.7617 0.71875V28.1269H121.59C121.009 25.3425 119.59 22.7631 117.506 20.7844Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5598 115.028C81.3977 111.522 83.0683 108.203 85.3845 105.429L121.887 62.2372V37.5H89.0742C86.4833 37.5 84.3867 35.4034 84.3867 32.8125V0H14.0742C6.31984 0 0.0117188 6.30813 0.0117188 14.0625V145.938C0.0117188 153.692 6.31984 160 14.0742 160H107.824C115.579 160 121.887 153.692 121.887 145.938V134.857L121.278 135.577C118.975 138.319 116.005 140.53 112.695 141.972L95.4739 149.438C90.6202 151.534 85.0017 150.792 80.8439 147.31C76.7377 143.863 74.957 138.484 76.202 133.266L80.5598 115.028ZM23.4492 28.125H70.3242C72.9152 28.125 75.0117 30.2216 75.0117 32.8125C75.0117 35.4034 72.9152 37.5 70.3242 37.5H23.4492C20.8583 37.5 18.7617 35.4034 18.7617 32.8125C18.7617 30.2216 20.8583 28.125 23.4492 28.125ZM23.4492 56.5625H98.4492C101.04 56.5625 103.137 58.6591 103.137 61.25C103.137 63.8409 101.04 65.9375 98.4492 65.9375H23.4492C20.8583 65.9375 18.7617 63.8409 18.7617 61.25C18.7617 58.6591 20.8583 56.5625 23.4492 56.5625ZM60.9492 122.188H23.4492C20.8583 122.188 18.7617 120.091 18.7617 117.5C18.7617 114.909 20.8583 112.812 23.4492 112.812H60.9492C63.5402 112.812 65.6367 114.909 65.6367 117.5C65.6367 120.091 63.5402 122.188 60.9492 122.188ZM23.4492 94.0625C20.8583 94.0625 18.7617 91.9659 18.7617 89.375C18.7617 86.7841 20.8583 84.6875 23.4492 84.6875H79.6992C82.2902 84.6875 84.3867 86.7841 84.3867 89.375C84.3867 91.9659 82.2902 94.0625 79.6992 94.0625H23.4492Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 146.09,
    y1: 55.9688,
    x2: 146.09,
    y2: 82.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 100.459,
    y1: 109.543,
    x2: 100.459,
    y2: 141.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 123.96,
    y1: 71.7227,
    x2: 123.96,
    y2: 120.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 107.676,
    y1: 0.71875,
    x2: 107.676,
    y2: 28.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 60.9492,
    y1: 0,
    x2: 60.9492,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotes);
export default __webpack_public_path__ + "static/media/no-notes.26efcd722f6a8770282e255a153cbc57.svg";
export { ForwardRef as ReactComponent };